import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { profile } from 'config/config'; // Importing profile configuration

/**
 * FilterSEOView class extends JetView to create a filter interface.
 */
export default class FilterSEOView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        const vthis = this; // Reference to the current instance

        console.log(screen); // Log the screen size
        console.log(document.body.offsetWidth); // Log the body width

        const filter = {
            // Filter configuration
            rows: [
                {
                    margin: 10,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'null',
                            options: [],
                            id: 'Countries', // ID for the country select
                        },
                        {
                            view: 'richselect', // Dropdown for language selection
                            name: 'Language',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'null',
                            options: [
                                { id: 'null', value: _('Default') },
                                {
                                    id: 'es',
                                    value: 'español (o castellano) (ES)',
                                },
                                { id: 'en', value: 'English (EN)' },
                                { id: 'pt', value: 'Portugues (PT)' },
                            ],
                            id: 'Language', // ID for the language select
                        },
                        { id: 'grav', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section layout
            css: 'father-container',
            height: screen == 'small' ? 150 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [filter], // Include filter in the layout
                },
            ],
        };

        const buttons = {
            // Button configuration
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav1', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Clear form values on click
                                $$('formFilter').setValues($$('formFilter').getCleanValues());
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Handle consult action
                                $$('b1').collapse();
                                $$('dataview1').hide();
                                const filterdata = $$('formFilter').getValues();
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                vthis.app.callEvent('partnerSettings:filter', [filterdata]);
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section = {
            // Accordion section configuration
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                    on: {
                        onAfterCollapse: function (id) {
                            // Event after collapse
                        },
                        onAfterExpand: function (id) {
                            // Event after expand
                        },
                    },
                },
            ],
        };

        return {
            // Return the main form configuration
            view: 'form',
            id: 'formFilter',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up data.
     */
    init() {
        const vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        const partners = profile.Partners; // List of partners

        function filter_partners(partners) {
            // Filter function for partners
            return partners.id == id_partner;
        }

        var partner = partners.filter(filter_partners); // Filtered partner
        var countries = partner[0].Countries; // Countries associated with the partner
        countries.shift(); // Remove the first element
        countries.unshift({ id: 'null', value: _('Default') }); // Add default option
        $$('Countries').define('options', countries); // Define options for country select
        $$('Countries').refresh(); // Refresh the country select

        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Conditional layout adjustment for small screens
                $$('grav').hide(); // Hide gravity element
                $$('grav1').hide(); // Hide gravity element
            }
        });
    }
}

// FILE DOCUMENTED
